import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';

import InputMaterial from '../shared/custom/input-material';
import SelectMaterial from '../shared/custom/select-material';

/**
 * Componente de filtros con estilo colapsable y abierto por defecto.
 * @param {Object} props - Propiedades del componente.
 */
const EstadoJugadoresFilters = ({ name, onChangeSearchPlayer, onChangeSearchTeam, teams, filterTeam }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                border: `1px solid ${theme.palette.border.main}`,
                borderRadius: '4px',
            }}
            mb={2}
            bgcolor={theme.palette.background.default}
        >
            {/* Encabezado Colapsable */}
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                    padding: '0 8px',
                    borderTopLeftRadius: '4px',
                    borderTopRightRadius: '4px',
                    height: '40px',
                    borderBottom: `1px solid ${theme.palette.border.main}`,
                    bgcolor: theme.palette.background.darkCard,
                    height: '40px',
                }}
            >
                <Typography sx={{ fontWeight: 500, textTransform: 'uppercase' }}>Filtros</Typography>
            </Box>

            <Box py={1} display={'flex'} flexDirection={{ xs: 'column', sm: 'row' }} gap={1}>
                <Box
                    px={1}
                    mt={1}
                    width={{ xs: '100%', sm: '50%' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={1}
                >
                    <InputMaterial
                        value={name}
                        onChange={onChangeSearchPlayer}
                        placeholder="Nombre del jugador"
                    />
                </Box>

                {/* Filtro por Equipo */}
                <Box
                    p={1}
                    width={{ xs: '100%', sm: '50%' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={1}
                >
                    <SelectMaterial
                        id="team-select"
                        options={
                            teams?.map((team) => ({
                                value: team.id,
                                label: team.name,
                            })) ?? []
                        }
                        onChange={onChangeSearchTeam}
                        value={filterTeam}
                        text="Equipos"
                        image={{ width: 20, height: 20 }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default EstadoJugadoresFilters;
